import React from 'react';

import { useFormContext } from 'react-hook-form';

import { CustomizedFormErrorMessage } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm';
import classes from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.module.scss';
import { TargetActivitySelect } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/TargetActivity/components/TargetActivitySelect/TargetActivitySelect';

export const TargetActivity = () => {
    const {
        formState: { errors },
    } = useFormContext<FormProps>();
    return (
        <>
            <div className={classes.inputTitle}>Target activity</div>
            <div className={classes.inputWrapper}>
                <TargetActivitySelect />
            </div>
            {errors.taskVersionHashCode && <CustomizedFormErrorMessage text={errors.taskVersionHashCode.message} />}
        </>
    );
};
